import React, {
  useEffect,
  useState,
} from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiRefreshCw,
  FiSearch,
  FiX,
} from "react-icons/fi";

import {config} from "../../../../../../utils/apiUrl";

import {
  fetchPlatformSellDeviceLeads,
  fetchPlatformSellDeviceLeadSummary,
  fetchPlatformSellDeviceLeadFilters,
  fetchPlatformSellDeviceLeadById,
  updatePlatformSellDeviceLeadStatus,
  updatePlatformSellDeviceLeadNotes,
  updatePlatformSellDeviceLeadOffer,
  setPlatformSellDeviceLeadFilters,
  selectPlatformSellDeviceLeadState,
} from "../../../../../../store/platform/platformSellDeviceLeadSlice";

import "./SellDeviceLeadsPage.css";


const imageUrl =
  (path) => {

    if (!path) {
      return "";
    }

    if (
      /^https?:\/\//i.test(
        path
      )
    ) {
      return path;
    }

    return `${config.site_api}${path}`;
  };


const SellDeviceLeadsPage =
  () => {

    const dispatch =
      useDispatch();

    const {
      leads,
      selectedLead,
      summary,
      filters,
      pagination,
      filterOptions,
      listLoading,
      detailsLoading,
      actionLoading,
      error,
    } =
      useSelector(
        selectPlatformSellDeviceLeadState
      );

    const [
      search,
      setSearch,
    ] =
      useState(
        filters.search ||
        ""
      );

    const [
      detailsOpen,
      setDetailsOpen,
    ] =
      useState(
        false
      );

    const [
      notes,
      setNotes,
    ] =
      useState(
        ""
      );

    const [
      offerPrice,
      setOfferPrice,
    ] =
      useState(
        ""
      );

    const [
      offerNotes,
      setOfferNotes,
    ] =
      useState(
        ""
      );

    const load =
      () => {
        dispatch(
          fetchPlatformSellDeviceLeads(
            filters
          )
        );

        dispatch(
          fetchPlatformSellDeviceLeadSummary()
        );
      };

    useEffect(
      () => {
        dispatch(
          fetchPlatformSellDeviceLeadFilters()
        );
      },
      [
        dispatch,
      ]
    );

    useEffect(
      () => {
        load();
      },
      [
        dispatch,
        filters.page,
        filters.limit,
        filters.status,
        filters.deviceType,
        filters.tenantId,
        filters.search,
      ]
    );

    useEffect(
      () => {
        setNotes(
          selectedLead?.notes ||
          ""
        );

        setOfferPrice(
          selectedLead?.offerPrice ??
          ""
        );

        setOfferNotes(
          selectedLead?.offerNotes ||
          ""
        );
      },
      [
        selectedLead,
      ]
    );

    const applySearch =
      () => {
        dispatch(
          setPlatformSellDeviceLeadFilters({
            page:
              1,
            search:
              search.trim(),
          })
        );
      };

    const openDetails =
      async (
        id
      ) => {
        setDetailsOpen(
          true
        );

        await dispatch(
          fetchPlatformSellDeviceLeadById(
            id
          )
        );
      };

    return (
      <div className="platform-sell-leads-page">

        <div className="platform-sell-leads-heading">
          <div>
            <span>
              MARKETING
            </span>

            <h2>
              Sell Device Leads
            </h2>

            <p>
              Review devices, customer images and offers.
            </p>
          </div>

          <button
            type="button"
            onClick={
              load
            }
          >
            <FiRefreshCw />
            Refresh
          </button>
        </div>


        <div className="platform-sell-summary-grid">
          <article>
            <span>
              Total
            </span>
            <strong>
              {
                summary.total
              }
            </strong>
          </article>

          <article>
            <span>
              New
            </span>
            <strong>
              {
                summary.NEW
              }
            </strong>
          </article>

          <article>
            <span>
              Offered
            </span>
            <strong>
              {
                summary.OFFERED
              }
            </strong>
          </article>

          <article>
            <span>
              Accepted
            </span>
            <strong>
              {
                summary.ACCEPTED
              }
            </strong>
          </article>
        </div>


        <div className="platform-sell-filter-card">

          <div className="platform-sell-search">
            <FiSearch />

            <input
              value={
                search
              }
              onChange={
                (
                  event
                ) =>
                  setSearch(
                    event.target.value
                  )
              }
              onKeyDown={
                (
                  event
                ) => {
                  if (
                    event.key ===
                    "Enter"
                  ) {
                    applySearch();
                  }
                }
              }
              placeholder="Search customer, brand, model..."
            />

            <button
              type="button"
              onClick={
                applySearch
              }
            >
              Search
            </button>
          </div>


          <select
            value={
              filters.status
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSellDeviceLeadFilters({
                    page:
                      1,
                    status:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Statuses
            </option>

            {
              filterOptions
                .statuses
                .map(
                  (
                    status
                  ) => (
                    <option
                      key={
                        status
                      }
                      value={
                        status
                      }
                    >
                      {
                        status
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.deviceType
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSellDeviceLeadFilters({
                    page:
                      1,
                    deviceType:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Device Types
            </option>

            {
              filterOptions
                .deviceTypes
                .map(
                  (
                    type
                  ) => (
                    <option
                      key={
                        type
                      }
                      value={
                        type
                      }
                    >
                      {
                        type
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.tenantId
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformSellDeviceLeadFilters({
                    page:
                      1,
                    tenantId:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Tenants
            </option>

            {
              filterOptions
                .tenants
                .map(
                  (
                    tenant
                  ) => (
                    <option
                      key={
                        tenant._id
                      }
                      value={
                        tenant._id
                      }
                    >
                      {
                        tenant.name ||
                        tenant.legalName
                      }
                    </option>
                  )
                )
            }
          </select>
        </div>


        {
          error
            ?
            (
              <div className="platform-sell-error">
                {
                  error.message ||
                  "Unable to load leads."
                }
              </div>
            )
            :
            null
        }


        <div className="platform-sell-table-card">
          <div className="platform-sell-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>
                    Customer
                  </th>
                  <th>
                    Device
                  </th>
                  <th>
                    Price
                  </th>
                  <th>
                    Source
                  </th>
                  <th>
                    Status
                  </th>
                  <th>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {
                  listLoading
                    ?
                    (
                      <tr>
                        <td
                          colSpan="6"
                          className="platform-sell-empty"
                        >
                          Loading...
                        </td>
                      </tr>
                    )
                    :
                    leads.length ===
                      0
                      ?
                      (
                        <tr>
                          <td
                            colSpan="6"
                            className="platform-sell-empty"
                          >
                            No leads found.
                          </td>
                        </tr>
                      )
                      :
                      leads.map(
                        (
                          lead
                        ) => (
                          <tr
                            key={
                              lead._id
                            }
                          >
                            <td>
                              <strong>
                                {
                                  lead.name
                                }
                              </strong>

                              <span>
                                {
                                  lead.mobile
                                }
                              </span>
                            </td>

                            <td>
                              <strong>
                                {
                                  lead.deviceType
                                }
                              </strong>

                              <span>
                                {
                                  lead.brand
                                } {
                                  lead.model
                                }
                              </span>

                              <small>
                                {
                                  lead.condition
                                }
                              </small>
                            </td>

                            <td>
                              <strong>
                                Expected ₹{
                                  Number(
                                    lead.expectedPrice ||
                                    0
                                  )
                                    .toLocaleString(
                                      "en-IN"
                                    )
                                }
                              </strong>

                              <span>
                                Offer ₹{
                                  Number(
                                    lead.offerPrice ||
                                    0
                                  )
                                    .toLocaleString(
                                      "en-IN"
                                    )
                                }
                              </span>
                            </td>

                            <td>
                              <strong>
                                {
                                  lead
                                    .tenantId
                                    ?.name ||
                                  "Public"
                                }
                              </strong>

                              <small>
                                {
                                  lead.sourceHost ||
                                  "-"
                                }
                              </small>
                            </td>

                            <td>
                              <span className="platform-sell-status">
                                {
                                  lead.status
                                }
                              </span>
                            </td>

                            <td>
                              <button
                                type="button"
                                className="platform-sell-view-button"
                                onClick={
                                  () =>
                                    openDetails(
                                      lead._id
                                    )
                                }
                              >
                                <FiEye />
                                View
                              </button>
                            </td>
                          </tr>
                        )
                      )
                }
              </tbody>
            </table>
          </div>


          <div className="platform-sell-pagination">
            <span>
              Page {
                pagination.page
              } / {
                pagination.totalPages
              } • {
                pagination.total
              } records
            </span>

            <div>
              <button
                type="button"
                disabled={
                  pagination.page <=
                  1
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformSellDeviceLeadFilters({
                        page:
                          pagination.page -
                          1,
                      })
                    )
                }
              >
                <FiChevronLeft />
              </button>

              <button
                type="button"
                disabled={
                  pagination.page >=
                  pagination.totalPages
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformSellDeviceLeadFilters({
                        page:
                          pagination.page +
                          1,
                      })
                    )
                }
              >
                <FiChevronRight />
              </button>
            </div>
          </div>
        </div>


        {
          detailsOpen
            ?
            (
              <div className="platform-sell-dialog-overlay">
                <div className="platform-sell-dialog">

                  <div className="platform-sell-dialog-header">
                    <div>
                      <span>
                        SELL DEVICE LEAD
                      </span>

                      <h3>
                        {
                          selectedLead
                            ?
                            `${selectedLead.brand || ""} ${selectedLead.model || ""}`
                            :
                            "Device Details"
                        }
                      </h3>
                    </div>

                    <button
                      type="button"
                      onClick={
                        () =>
                          setDetailsOpen(
                            false
                          )
                      }
                    >
                      <FiX />
                    </button>
                  </div>


                  {
                    detailsLoading
                      ?
                      (
                        <div className="platform-sell-dialog-loading">
                          Loading...
                        </div>
                      )
                      :
                      selectedLead
                        ?
                        (
                          <div className="platform-sell-dialog-body">

                            <div className="platform-sell-detail-grid">
                              <div>
                                <span>
                                  Customer
                                </span>
                                <strong>
                                  {
                                    selectedLead.name
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Mobile
                                </span>
                                <strong>
                                  {
                                    selectedLead.mobile
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Device
                                </span>
                                <strong>
                                  {
                                    selectedLead.deviceType
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Brand / Model
                                </span>
                                <strong>
                                  {
                                    selectedLead.brand
                                  } {
                                    selectedLead.model
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Condition
                                </span>
                                <strong>
                                  {
                                    selectedLead.condition
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Expected
                                </span>
                                <strong>
                                  ₹{
                                    Number(
                                      selectedLead.expectedPrice ||
                                      0
                                    )
                                      .toLocaleString(
                                        "en-IN"
                                      )
                                  }
                                </strong>
                              </div>
                            </div>


                            <div className="platform-sell-images">
                              {
                                Array.isArray(
                                  selectedLead.images
                                )
                                  ?
                                  selectedLead.images.map(
                                    (
                                      image,
                                      index
                                    ) => (
                                      <a
                                        key={
                                          `${image.path}-${index}`
                                        }
                                        href={
                                          imageUrl(
                                            image.path
                                          )
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {console.log('.............................', `${process.env.REACT_APP_IMAGE_URL}${image.path}`)}
                                        <img
                                          src={
                                            imageUrl(
                                              `${process.env.REACT_APP_IMAGE_URL}${image.path}`
                                            )
                                          }
                                          alt={
                                            `Device ${index + 1}`
                                          }
                                        />
                                      </a>
                                    )
                                  )
                                  :
                                  null
                              }
                            </div>


                            <div className="platform-sell-status-row">
                              <select
                                value={
                                  selectedLead.status
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    dispatch(
                                      updatePlatformSellDeviceLeadStatus({
                                        id:
                                          selectedLead._id,
                                        status:
                                          event.target.value,
                                      })
                                    )
                                }
                              >
                                {
                                  filterOptions
                                    .statuses
                                    .map(
                                      (
                                        status
                                      ) => (
                                        <option
                                          key={
                                            status
                                          }
                                          value={
                                            status
                                          }
                                        >
                                          {
                                            status
                                          }
                                        </option>
                                      )
                                    )
                                }
                              </select>
                            </div>


                            <div className="platform-sell-offer-card">
                              <h4>
                                Make / Update Offer
                              </h4>

                              <div>
                                <input
                                  type="number"
                                  min="0"
                                  value={
                                    offerPrice
                                  }
                                  onChange={
                                    (
                                      event
                                    ) =>
                                      setOfferPrice(
                                        event.target.value
                                      )
                                  }
                                  placeholder="Offer price"
                                />

                                <input
                                  value={
                                    offerNotes
                                  }
                                  onChange={
                                    (
                                      event
                                    ) =>
                                      setOfferNotes(
                                        event.target.value
                                      )
                                  }
                                  placeholder="Offer notes"
                                />

                                <button
                                  type="button"
                                  disabled={
                                    actionLoading
                                  }
                                  onClick={
                                    () =>
                                      dispatch(
                                        updatePlatformSellDeviceLeadOffer({
                                          id:
                                            selectedLead._id,
                                          offerPrice:
                                            Number(
                                              offerPrice
                                            ),
                                          offerNotes,
                                        })
                                      )
                                  }
                                >
                                  Save Offer
                                </button>
                              </div>
                            </div>


                            <div className="platform-sell-notes">
                              <label>
                                Marketing Notes
                              </label>

                              <textarea
                                rows="4"
                                value={
                                  notes
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    setNotes(
                                      event.target.value
                                    )
                                }
                              />

                              <button
                                type="button"
                                onClick={
                                  () =>
                                    dispatch(
                                      updatePlatformSellDeviceLeadNotes({
                                        id:
                                          selectedLead._id,
                                        notes,
                                      })
                                    )
                                }
                              >
                                Save Notes
                              </button>
                            </div>

                          </div>
                        )
                        :
                        null
                  }

                </div>
              </div>
            )
            :
            null
        }

      </div>
    );
  };


export default SellDeviceLeadsPage;
